export function uploadFile(e, input, button) {
    let item = e?.target;

    if (item?.files && item.files[0]) {
        item.closest('label').classList.add('full');
        button.hidden = false;
        item.closest('label').querySelector('.btn-upload span').innerHTML = item.files[0].name
    } else {
        item.closest('label').classList.remove('full');
        button.hidden = true;
        input.value = '';
        item.closest('label').querySelector('.btn-upload span').innerHTML = item.closest('label').querySelector('.btn-upload span').dataset.default
    }
}
